module.exports = __webpack_public_path__ + "static/media/cross-red.75b186db.svg";